export default __webpack_public_path__ + "static/CABL-705dbefd0070b862c4c77a4502ebe5fb.jpg";